var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { stepUpdated } from '../../../../redux/questionnaire/questionnaire.slice';
import { updateNextQuestion } from '../../../../redux/questionnaire/thunks';
import { FieldType, QuestionnaireFlow } from '../../../../redux/questionnaire/typings';
import { closeModal } from '../../../../redux/ui/ui.slice';
import { ButtonType, ModalType } from '../../../../redux/ui/typings';
import { t } from '../../../../strings/i18n/i18n';
import { DisputeFeature } from '../../../../typings';
import createCase from '../../../../redux/cases/createCase';
import fetchQuestionnaire from '../../../../redux/questionnaire/fetchQuestionnaire';
import { Analytics } from '../../../../helpers/analyticsMiddleware';
import getRedisputeEligibility from '../../../../redux/transactionEligible/getRedisputeEligibility';
import { DOUBLE_CHARGE_QUESTION_ID, RECURRING_TABLE_LIST_QUESTION_ID } from '../../../../const/questionIds';
import { closeModalHelper } from './closeHandlers';
import { errorButtonHandler, errorButtonText } from './errorHandlers';
import { validateAdditionalContent, validateFormError } from './validationHelper';
var closeButtonTranslationKey = 'button.close';
export var determinePrimaryButtonTitleAndText = function (step, _a, feature, isRedispute, lowBalanceDisputeApplied, currentQuestionId) {
    var source = _a.source, count = _a.count;
    if (feature === ModalType.FAQs) {
        return {
            primaryText: t(closeButtonTranslationKey),
            primaryDataReason: 'Close',
            primaryDataType: Analytics.DisputeTransaction,
            primaryDataTitle: Analytics.DisputeTransaction
        };
    }
    switch (step) {
        case QuestionnaireFlow.Start: {
            if (isRedispute) {
                return {
                    primaryText: "".concat(t('button.redispute')),
                    primaryDataType: Analytics.Redispute,
                    primaryDataReason: 'yes redispute transaction'
                };
            }
            return {
                primaryText: "".concat(t('button.getStarted')),
                primaryDataType: "let's get started"
            };
        }
        case QuestionnaireFlow.CreditDetails:
            return {
                primaryText: t('button.noDontDisputeIt'),
                primaryDataType: "no don't dispute it"
            };
        case QuestionnaireFlow.APIError:
        case QuestionnaireFlow.CantIdentifyDup: {
            var primaryDataType = isRedispute
                ? Analytics.Redispute
                : Analytics.DisputeTransaction;
            return {
                primaryDataType: primaryDataType,
                primaryText: t(closeButtonTranslationKey),
                primaryDataReason: Analytics.Close
            };
        }
        case QuestionnaireFlow.CancelDispute:
            return {
                primaryText: t(closeButtonTranslationKey),
                primaryDataReason: 'close',
                primaryDataType: Analytics.CreditAlreadyIssued
            };
        case QuestionnaireFlow.RedisputeNotEligible:
            return {
                primaryText: t(closeButtonTranslationKey),
                primaryDataReason: 'Close',
                primaryDataType: Analytics.Redispute
            };
        case QuestionnaireFlow.InProgress: {
            var props = {
                primaryText: t('button.nextQuestion'),
                primaryDataReason: 'Next question',
                primaryDataType: Analytics.DisputeTransaction
            };
            var tableListQuestionProps = {
                primaryText: t('questionnaire.continue'),
                primaryDataReason: 'Continue',
                primaryDataType: Analytics.RecurringTransactions
            };
            return __assign(__assign({}, (currentQuestionId === RECURRING_TABLE_LIST_QUESTION_ID
                ? tableListQuestionProps
                : props)), { primaryDataTitle: Analytics.DisputeTransaction });
        }
        case QuestionnaireFlow.CancelQuestionnaire:
            return {
                primaryText: "".concat(t('button.cancelQuestionnaire')),
                primaryDataReason: 'Yes-cancel-dispute',
                primaryDataType: Analytics.DisputeTransaction,
                primaryDataTitle: Analytics.DisputeTransaction
            };
        case QuestionnaireFlow.RedisputeReview:
            return {
                primaryText: "".concat(t('button.submitDispute')),
                primaryDataReason: 'Submit dispute',
                primaryDataType: Analytics.Redispute
            };
        case QuestionnaireFlow.Review:
            return {
                primaryText: "".concat(t('button.submitDispute')),
                primaryDataReason: 'Submit dispute',
                primaryDataType: Analytics.DisputeTransaction,
                primaryDataTitle: Analytics.DisputeTransaction
            };
        case QuestionnaireFlow.ContactFraud:
            return {
                primaryText: "".concat(t('button.done')),
                primaryDataReason: 'Done',
                primaryDataType: Analytics.DisputeTransaction,
                primaryDataTitle: Analytics.DisputeTransaction
            };
        case QuestionnaireFlow.BusinessError: {
            var _b = errorButtonText(ButtonType.Primary, {
                source: source,
                count: count
            }), text = _b.text, dataReason = _b.dataReason;
            return {
                primaryText: text,
                primaryDataReason: dataReason,
                primaryDataType: Analytics.DisputeTransaction,
                primaryDataTitle: Analytics.DisputeTransaction
            };
        }
        case QuestionnaireFlow.End:
            if (lowBalanceDisputeApplied) {
                return {
                    primaryText: "".concat(t('button.ok')),
                    primaryDataReason: 'Ok',
                    primaryDataType: Analytics.DisputeTransaction,
                    primaryDataTitle: Analytics.DisputeTransaction
                };
            }
            return {
                primaryText: "".concat(t('button.done')),
                primaryDataReason: 'Done',
                primaryDataType: isRedispute
                    ? Analytics.Redispute
                    : Analytics.DisputeTransaction,
                primaryDataTitle: Analytics.DisputeTransaction
            };
        case QuestionnaireFlow.Exit:
            return {
                primaryText: t(closeButtonTranslationKey),
                primaryDataReason: 'Close',
                primaryDataType: Analytics.DisputeTransaction,
                primaryDataTitle: Analytics.DisputeTransaction
            };
        default:
            return {
                primaryText: "".concat(t('button.ok')),
                primaryDataReason: 'Ok',
                primaryDataType: Analytics.DisputeTransaction,
                primaryDataTitle: Analytics.DisputeTransaction
            };
    }
};
var questionnairePrimaryButtonHandlers = function (step, error, isRedisputeStart) {
    return function (dispatch, getState) {
        switch (step) {
            case QuestionnaireFlow.Start: {
                if (isRedisputeStart) {
                    var _a = getState(), _b = _a.appConfig, accountId = _b.accountId, operationId = _b.operationId, apigeeURL = _a.mfeConfig.apigeeURL, _c = _a.transactionData, transactionId = _c.transactionId, transactionAmount = _c.transactionAmount, transactionDate = _c.transactionDate;
                    return dispatch(getRedisputeEligibility({
                        accountId: accountId,
                        apiHost: apigeeURL,
                        operationId: operationId,
                        transactionId: transactionId,
                        transactionAmount: transactionAmount,
                        transactionDate: transactionDate
                    }));
                }
                return dispatch(fetchQuestionnaire());
            }
            case QuestionnaireFlow.CreditDetails:
                return dispatch(stepUpdated(QuestionnaireFlow.CancelDispute));
            case QuestionnaireFlow.InProgress: {
                var _d = getState(), _e = _d.questionnaire, currentQuestion = _e.currentQuestion, doubleChargedTransactions = _e.doubleChargedTransactions, doubleChargeEnabled = _d.featureFlags.doubleChargeEnabled;
                var answer = currentQuestion.answers[0];
                var answerOptions = answer.answerOptions;
                var nextQuestionId = answerOptions[0].nextQuestionId;
                if (doubleChargeEnabled &&
                    nextQuestionId === DOUBLE_CHARGE_QUESTION_ID &&
                    (doubleChargedTransactions === null || doubleChargedTransactions === void 0 ? void 0 : doubleChargedTransactions.length) !== 1) {
                    return dispatch(stepUpdated(QuestionnaireFlow.CantIdentifyDup));
                }
                return dispatch(updateNextQuestion());
            }
            case QuestionnaireFlow.RedisputeReview:
            case QuestionnaireFlow.Review: {
                return dispatch(createCase());
            }
            case QuestionnaireFlow.BusinessError:
                return dispatch(errorButtonHandler(ButtonType.Primary, error));
            case QuestionnaireFlow.End:
                return dispatch(closeModalHelper(DisputeFeature.DisputeCenter));
            case QuestionnaireFlow.CancelQuestionnaire:
            case QuestionnaireFlow.CantIdentifyDup:
            case QuestionnaireFlow.ContactFraud:
            case QuestionnaireFlow.Exit:
            case QuestionnaireFlow.CancelDispute:
            case QuestionnaireFlow.APIError:
            case QuestionnaireFlow.RedisputeNotEligible:
                return dispatch(closeModalHelper());
            default:
                return null;
        }
    };
};
export var determinePrimaryButtonHandler = function (step, error) {
    return function (dispatch, getState) {
        var _a = getState(), ui = _a.ui, isRedispute = _a.questionnaire.isRedispute;
        switch (ui.modalType) {
            case ModalType.FAQs:
                return dispatch(closeModal());
            case ModalType.Questionnaire:
                return dispatch(questionnairePrimaryButtonHandlers(step, error, isRedispute));
            case ModalType.DisputeDetail:
                return dispatch(closeModal());
            default:
                return null;
        }
    };
};
var checkIfCurrentQuestionAnswered = function (currentQuestion, duplicateTransactions, userAnswers) {
    if (!(currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.answers)) {
        return false;
    }
    var fieldType = currentQuestion.answers[0].fieldType;
    if (fieldType === FieldType.TableList) {
        var isListEmpty = !duplicateTransactions.length;
        return isListEmpty || duplicateTransactions.some(function (txn) { return txn.selected; });
    }
    return !!userAnswers.find(function (currentAnswer) {
        return (currentAnswer === null || currentAnswer === void 0 ? void 0 : currentAnswer.id) === (currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.id) && (currentAnswer === null || currentAnswer === void 0 ? void 0 : currentAnswer.answers[0]);
    });
};
export var handlePrimaryButtonClick = function () { return function (dispatch, getState) {
    var _a;
    var _b = getState(), postCasesCount = _b.caseDetails.postCasesCount, userAnswers = _b.userAnswers, _c = _b.questionnaire, step = _c.step, currentQuestion = _c.currentQuestion, source = _c.businessError.source, duplicateTransactions = _c.duplicateTransactions, isRedispute = _c.isRedispute, formError = _b.ui.formError;
    var errorData = {
        source: source,
        count: postCasesCount
    };
    var isCurrentQuestionAnswered = checkIfCurrentQuestionAnswered(currentQuestion, duplicateTransactions, userAnswers);
    var shouldRenderFormError = !isCurrentQuestionAnswered &&
        (step === QuestionnaireFlow.RecognizeCharge ||
            step === QuestionnaireFlow.InProgress);
    if (isCurrentQuestionAnswered) {
        var _d = validateAdditionalContent({
            userAnswers: userAnswers,
            currentQuestion: currentQuestion
        }), isAdditionalContent = _d.isAdditionalContent, errorMessage = _d.errorMessage;
        if (!formError &&
            isAdditionalContent &&
            errorMessage &&
            step === QuestionnaireFlow.InProgress) {
            return dispatch(validateFormError(null, true, errorMessage));
        }
    }
    if (!formError && shouldRenderFormError) {
        return dispatch(validateFormError((_a = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.answers[0]) === null || _a === void 0 ? void 0 : _a.fieldType, false));
    }
    if (!formError) {
        return dispatch(determinePrimaryButtonHandler(step, errorData));
    }
    if (formError && step === QuestionnaireFlow.CancelQuestionnaire) {
        return dispatch(questionnairePrimaryButtonHandlers(step, errorData, isRedispute));
    }
    return null;
}; };
//# sourceMappingURL=primaryHandlers.js.map